import { render, staticRenderFns } from "./RecallDashboardDetail.vue?vue&type=template&id=e704f784&"
import script from "./RecallDashboardDetail.vue?vue&type=script&lang=js&"
export * from "./RecallDashboardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports